import { Outlet, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

const AdminLayout = () => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

    useEffect(() => {
        // Check for token
        const token = localStorage.getItem('admin_token');
        setIsAuthenticated(!!token);
    }, []);

    if (isAuthenticated === null) {
        return <div>Loading...</div>;
    }

    if (!isAuthenticated) {
        return <Navigate to="/admin/login" replace />;
    }

    return (
        <div className="admin-layout" style={{ display: 'flex', minHeight: '100vh', backgroundColor: 'var(--bg-layout)' }}>
            {/* Sidebar */}
            <aside style={{
                width: '250px',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(10px)',
                borderRight: '1px solid rgba(255, 255, 255, 0.2)',
                color: 'white',
                padding: '20px'
            }}>
                <h2 style={{ marginBottom: '30px', borderBottom: '1px solid rgba(255, 255, 255, 0.1)', paddingBottom: '15px', color: '#fff', fontSize: '18px' }}>
                    中国钒荣网产业地图管理后台
                </h2>
                <nav>
                    <ul style={{ listStyle: 'none', padding: 0 }}>
                        <li style={{ marginBottom: '10px' }}>
                            <a href="/admin/dashboard" style={{ color: '#fff', textDecoration: 'none', display: 'block', padding: '10px', borderRadius: '5px', backgroundColor: 'rgba(0, 0, 0, 0.2)' }}>
                                系统概览
                            </a>
                        </li>
                        <li style={{ marginBottom: '10px' }}>
                            <a href="/admin/validation" style={{ color: 'rgba(255, 255, 255, 0.8)', textDecoration: 'none', display: 'block', padding: '10px' }}>
                                数据验证
                            </a>
                        </li>
                        <li style={{ marginBottom: '10px' }}>
                            <a href="/admin/intelligence" style={{ color: 'rgba(255, 255, 255, 0.8)', textDecoration: 'none', display: 'block', padding: '10px' }}>
                                数据情报室
                            </a>
                        </li>
                        <li style={{ marginBottom: '10px' }}>
                            <a href="/admin/monitoring" style={{ color: 'rgba(255, 255, 255, 0.8)', textDecoration: 'none', display: 'block', padding: '10px' }}>
                                数据监控
                            </a>
                        </li>
                        <li style={{ marginTop: 'auto', paddingTop: '20px', borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}>
                            <button
                                onClick={() => {
                                    localStorage.removeItem('admin_token');
                                    window.location.href = '/admin/login';
                                }}
                                style={{ background: 'none', border: 'none', color: '#fc8181', cursor: 'pointer', padding: '10px', fontSize: '16px', width: '100%', textAlign: 'left' }}
                            >
                                退出登录
                            </button>
                        </li>
                    </ul>
                </nav>
            </aside>

            {/* Main Content */}
            <main style={{ flex: 1, padding: '30px' }}>
                <Outlet />
            </main>
        </div>
    );
};

export default AdminLayout;
